export async function handle500Error(error, originalRequest) {
    return Promise.reject(error);
}
